/*
 *@Description: 日期范围限制
 *@param {arg} type
 *@return [type]
*/
import { RESPONSE_CODE } from '@public/http/config'
import { interfaceWaitHandle } from '@public/utils/common'

const dayTime = 24 * 3600 * 1000 // 一天的毫秒数
export default {
  data() {
    return {
      timeRefList: ['timeStart', 'timeEnd'],
      hanldeDayRange: 180, // 可操作的时间范围
      dateDayRange: 30, // 可选择的时间范围
      startKey: 'beginDate', // 开始时间字段
      endKey: 'endDate', // 结束时间字段
      slotParams: {}, // 自定义的搜索对象
      dateFormat: 'YYYY-MM-DD HH:mm:ss'
    }
  },
  computed: {
    pickerOptionsStart() {
      const space = this.hanldeDayRange * dayTime // 最小可操作的时间范围
      return {
        disabledDate: dateTime => {
          // 如果存在结束时间, 最大时间是结束时间; 否则最大时间就是当天的23:59:59;
          // 最小时间是结束时间减去对多能操作的时间范围, 默认180天
          // const timeEnd = this.validatenull(this.slotParams) ? this.$refs.params.searchForm[this.endKey] : this.slotParams[this.endKey]
          const maxTime = new Date(this.$taday.end).getTime()
          const minTime = maxTime - space
          const selectTime = dateTime.getTime()
          return selectTime > maxTime || selectTime < minTime || selectTime > new Date().getTime()
        }
      }
    },
    pickerOptionsEnd() {
      const space = this.dateDayRange * dayTime // 可操作范围天数
      return {
        disabledDate: dateTime => {
          // 如果存在开始时间, 最小时间是开始时间; 否则最小时间就是当天的 00:00:00;
          const timeStart = this.validatenull(this.slotParams) ? this.$refs.params.searchForm[this.startKey] : this.slotParams[this.startKey]
          const startDate = new Date(timeStart || this.$taday.start)
          // 设置结束时间的时分秒
          dateTime.setHours(startDate.getHours())
          dateTime.setMinutes(startDate.getMinutes())
          dateTime.setSeconds(startDate.getSeconds())
          const selectTime = dateTime.getTime()
          const minTime = startDate.getTime()
          const maxTime = startDate.getTime() + space
          return selectTime < minTime || selectTime > maxTime || selectTime > new Date().getTime()
        }
      }
    },
    uppickerOptionsStart() {
      const space = this.hanldeDayRange * dayTime // 最小可操作的时间范围
      return {
        disabledDate: dateTime => {
          // 如果存在结束时间, 最大时间是结束时间; 否则最大时间就是当天的23:59:59;
          // 最小时间是结束时间减去对多能操作的时间范围, 默认180天
          // const timeEnd = this.validatenull(this.slotParams) ? this.$refs.params.searchForm[this.endKey] : this.slotParams[this.endKey]
          const maxTime = new Date(this.$taday.end).getTime()
          const minTime = maxTime - space
          const selectTime = dateTime.getTime()
          return selectTime > maxTime - 8.64e7 * (this.topTime ? this.topTime : 1) || selectTime < minTime || selectTime > new Date().getTime()
        }
      }
    },
    uppickerOptionsEnd() {
      const space = this.dateDayRange * dayTime // 可操作范围天数
      return {
        disabledDate: dateTime => {
          // 如果存在开始时间, 最小时间是开始时间; 否则最小时间就是当天的 00:00:00;
          const timeStart = this.validatenull(this.slotParams) ? this.$refs.params.searchForm[this.startKey] : this.slotParams[this.startKey]
          const startDate = new Date(timeStart || this.$taday.start)
          // 设置结束时间的时分秒
          dateTime.setHours(startDate.getHours())
          dateTime.setMinutes(startDate.getMinutes())
          dateTime.setSeconds(startDate.getSeconds())
          const selectTime = dateTime.getTime()
          const minTime = startDate.getTime()
          const maxTime = startDate.getTime() + space
          return selectTime < minTime || selectTime > maxTime || selectTime > new Date().getTime() - 8.64e7 * (this.topTime ? this.topTime : 1)
        }
      }
    }
  },
  methods: {
    changeStart(time) {
      const space = this.dateDayRange * dayTime
      const value = time.value || time
      const selectTime = value && new Date(value).getTime()
      // 获取结束时间
      const endDate = this.validatenull(this.slotParams) ? this.$refs.params.searchForm[this.endKey] : this.slotParams[this.endKey]
      const endTime = endDate && new Date(endDate || this.$taday.end).getTime()
      // 超过范围则结束时间是开始时间当天的23:59:59
      if (endTime < selectTime || (endTime - selectTime) > space) {
        const dayEndStr = this.getDayEnd(value)
        // 给crud搜索表单赋值
        // this.$refs.params.searchForm[this.endKey] = dayEndStr
        // 给自定义插槽表单赋值
        if (!this.validatenull(this.slotParams)) {
          this.slotParams[this.endKey] = dayEndStr
        }
      }
    },
    getEndTime(val) {
      const date = new Date(val)
      const y = date.getFullYear()
      let m = date.getMonth() + 1
      m = m < 10 ? '0' + m : m
      let d = date.getDate()
      d = d < 10 ? '0' + d : d
      return `${y}-${m}-${d} 23:59:59`
    },
    // 获取某天23:59:59的字符串时间
    getDayEnd(date) {
      const start = new Date(date).getTime()
      const end = new Date(this.slotParams[this.endKey]).getTime()
      const space = this.dateDayRange * 24 * 3600 * 1000
      if (start + space < end) {
        return this.getEndTime(start + space)
      } else {
        return this.getEndTime(start)
      }
      // const day = date.split(' ')[0] + 30
      // return new Date(day).toJSON().split('T')[0] + ' 23:59:59'
    },
    // avue-编辑方法
    async updateFun(item, index, done, oldFormData, loading) {
      if (this.eidtBeforeCallback()) {
        const { code, msg } = await this.COM_HTTP.reqUpdate(item)
        loading()
        if (code === RESPONSE_CODE.SUCCESS) {
          // 延时1秒后关闭弹窗
          interfaceWaitHandle(() => {
            this.$message.success(this.$lang(msg))
            this.searchFun()
            done()
            this.eidtCallback()
          })
        } else {
          this.$message.warning(this.$lang(msg))
        }
      } else {
        loading()
      }
    }
  }
}
